import { render } from "./Button.vue?vue&type=template&id=1e20abe3&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=1e20abe3&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e20abe3"]])

export default __exports__